import React, {Component} from 'react';
import WhitePortlet from '../utils/WhitePortlet';
import i18next from 'i18next';
import * as sitesApi from './../../api/sites-api';
import * as viewUtils from '../../utils/view-utils';
import SiteSocket from './../../socket/SiteSocket';
import * as blockUtils from '../../utils/BlockUtils';
import SiteAlertList from './SiteAlertList';

class SiteAlertContainer extends Component {
  constructor(props) {
    super(props);

    this.getSites = this.getSites.bind(this);

    this.state = {
      sites: [],
    };
  }

  componentDidMount() {
    SiteSocket.getInstance().connect();
    this.getSites();
  }

  componentWillUnmount() {
    SiteSocket.getInstance().disconnect();
  }

  getSites() {
    blockUtils.blockUI();
    sitesApi.getSitesWithIssues().then((response) => {
      blockUtils.unblockUI();
      const sites = response.data;

      this.setState({
        sites: sites,
      });
    }).catch((error) => {
      blockUtils.unblockUI();
      window.showAlert(i18next.t('error'), viewUtils.getErrorDescription(error));
    });
  }

  getRedirectFunction(siteId) {
    blockUtils.blockUI();
    sitesApi.getHapiTokenForRedirect(siteId).then((response) => {
      blockUtils.unblockUI();
      const hapiToken = response.data;
      if (hapiToken) {
        window.open(hapiToken).focus();
      }
    }).catch((error) => {
      blockUtils.unblockUI();
      window.showAlert(i18next.t('error'), viewUtils.getErrorDescription(error));
    });
  }

  render() {
    return (
      <WhitePortlet caption={i18next.t('dashboard.title', {count: 2})} icon="icon-bar-chart">
        <div className="dashboard-legend">
          <i className="fa fa-warning"></i>
          <span>This dashboard shows only <span>PWA websites</span>. For monitoring SPK sites, check DG2 or locally installed access control systems.</span>
        </div>
        <SiteAlertList
          getData={this.getSites}
          tableId="site-alert-table"
          sites={this.state.sites}
          totalPages={this.state.totalPages}
          totalElements={this.state.totalElements}
          redirectFunction={this.getRedirectFunction}
        />
      </WhitePortlet>
    );
  }
}

SiteAlertContainer.propTypes = {};

export default SiteAlertContainer;
